/* ============================================================
   Cathaya × Minimog — Animations
   Independent IntersectionObserver for [data-cathaya-animate] / .cathaya-animate-on-scroll,
   plus button ripple for Cathaya brand buttons.
   Coexists with Minimog animations.js (m-scroll-trigger system).
   ============================================================ */

(function () {
  "use strict";

  var ANIMATE_SELECTOR = "[data-cathaya-animate], .cathaya-animate-on-scroll";
  var BUTTON_SELECTOR  = ".cathaya-btn, .m-button--primary, .m-button--secondary";
  var STAGGER_MS       = 100;

  var observer = null;

  function ensureObserver() {
    if (observer || !("IntersectionObserver" in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, index) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = (parseInt(el.dataset.cathayaDelay, 10) || index * STAGGER_MS);
        setTimeout(function () { el.classList.add("is-visible"); }, delay);
        observer.unobserve(el);
      });
    }, {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    });
    return observer;
  }

  function observe(root) {
    var obs = ensureObserver();
    if (!obs) {
      root.querySelectorAll(ANIMATE_SELECTOR).forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    root.querySelectorAll(ANIMATE_SELECTOR).forEach(function (el) {
      if (el.dataset.cathayaObserved === "true") return;
      el.dataset.cathayaObserved = "true";
      obs.observe(el);
    });
  }

  function spawnRipple(button, clientX, clientY) {
    if (button.disabled) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var rect = button.getBoundingClientRect();
    var ripple = document.createElement("span");
    ripple.className = "cathaya-ripple";
    ripple.style.left = (clientX - rect.left) + "px";
    ripple.style.top  = (clientY - rect.top)  + "px";
    button.classList.add("cathaya-ripple-host");
    button.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 700);
  }

  function onClick(e) {
    var btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    spawnRipple(btn, e.clientX, e.clientY);
  }

  function init(root) {
    root = root || document;
    observe(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
    document.addEventListener("click", onClick, { passive: true });
  });

  // Shopify Theme Editor: rebind when a section reloads
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
